import { Roles } from "../rbac/rbac";
import { GroupRole } from "../group/group";

// 認証方式の一括変更での外部ユーザーIDの設定方法
export type BatchExternalUserIdOption = "accountName" | "email";

export const UserConst = {
  MAX_NAME_LENGTH: 64,
  MAX_GROUPS_LENGTH: 30,
} as const;

export type User = {
  id: string;
  orgId: string;
  accountName: string;
  name: string;
  disabled: boolean;
  roles: Array<Roles>;
  totp?: {
    disabled: boolean;
    enabledAt?: string;
    secret: string;
  } | null;
  groupsRoles: { [key: string]: GroupRole };
  emails: Array<string>;
  authMethod: UserAuthMethod;
  externalUserId?: string;
};

export type UserAuthMethod = "password" | "saml";

export function validateUserName(name: string): string | undefined {
  if (name.trim().length === 0) {
    return `氏名を入力してください。`;
  }
  if (name.length > UserConst.MAX_NAME_LENGTH) {
    return `${UserConst.MAX_NAME_LENGTH}文字まで入力できます。`;
  }
  return undefined;
}

export function validateRoles(roles: Roles[]): string | undefined {
  if (roles.length === 0) {
    return "ロールを指定してください。";
  }
  if (roles.includes("Admin") && roles.length > 1) {
    return "特権管理者ロールと他のロールを同時に指定することはできません。";
  }
  return undefined;
}

export function validateRoleGroupConsistency(
  roles: Roles[],
  groupsRoles: {
    [key: string]: GroupRole;
  },
): string | undefined {
  if (roles.includes("Staff") && Object.keys(groupsRoles).length === 0) {
    return "グループを選択してください。";
  }
  if (!roles.includes("Staff") && Object.keys(groupsRoles).length > 0) {
    return "グループに所属することのできないロールです。";
  }
  return undefined;
}

export function validateGroupsRolesSelected(groupsRoles: {
  [key: string]: GroupRole;
}): string | undefined {
  if (Object.keys(groupsRoles).includes("")) {
    return "グループを選択してください。";
  }
  return;
}

export function validateGroupsRolesLength(groupsRoles: {
  [key: string]: GroupRole;
}): string | undefined {
  if (Object.keys(groupsRoles).length > UserConst.MAX_GROUPS_LENGTH) {
    return `グループは${UserConst.MAX_GROUPS_LENGTH}個まで選択できます。`;
  }
  return;
}
